import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";
import { withTheme } from "styled-components";

function NumberCircle({ children, theme, width, height }) {
  return (
    <Box
      borderRadius="50%"
      borderStyle="solid"
      borderWidth="2px"
      borderColor={theme.colors.foreground}
      width={width}
      height={height}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Text fontSize={32} fontWeight={700} fontFamily="bold">
        {children}
      </Text>
    </Box>
  );
}

NumberCircle.defaultProps = {
  height: 72,
  width: 72,
};

NumberCircle.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default withTheme(NumberCircle);
